/**
 * Application-wide constants to eliminate magic numbers.
 */

// Emotion detection
export const EMOTION_DETECTION_INTERVAL_MS = 100;

// Audio streamer
export const AUDIO_INITIAL_BUFFER_TIME = 0.05;
export const AUDIO_SCHEDULE_AHEAD_TIME = 0.1;
export const AUDIO_POLL_INTERVAL_MS = 50;

// Thinking state
export const THINKING_TRIGGER_DELAY_MS = 300;

// Interaction debounce
export const PALM_LATCH_DEBOUNCE_FRAMES = 10;
export const FACE_TOUCH_DEBOUNCE_FRAMES = 10;
export const PALM_GRACE_PERIOD_MS = 2000;

// Volume
export const VOLUME_SPEAKING_THRESHOLD = 0.01;

// Video
export const VIDEO_DOWNSCALE_FACTOR = 0.25;

// PDF
export const PDF_SCALE = 2;
